
export default theme => ({
  dialogPaper: {
    minHeight: '600px',
    minWidth: '600px'
  }
})
